import { DataTable } from "primereact/datatable";
import "./css/templatedata.css";
import { OverlayPanel } from "primereact/overlaypanel";
import CommonLoaderBlue from "../../../../components/Loader/LoaderBlue";
import React, { useEffect, useState } from "react";
import moment from "moment-timezone";
import { Column } from "primereact/column";
import NotFoundData from "../../customer_profile/CustomerProfileNew/Components/Payments/Common/Notfound/Notfound";
import { CheckMark } from "../../customer_profile/CustomerProfileNew/Components/Files/components/CustomerFilesData/assets/Assets";
import DeleteTemplate from "./DeleteTemplate/DeleteTemplate";
import DownloadTemplate from "./DownloadTemplate/DownloadTemplate";
import { CreateTemplate } from "./CreateTemplate/CreateTempate";
import { api } from "../../../../../utility/AxiosInceptor";
import TemplateAction from "./templateaction/TemplateAction";
const TemplateData = ({
  handleCreateTemplate,
  refreshTemplateData,
  setRefreshTemplateData,
}) => {
  const [allTemplateData, setAllTemplateData] = React.useState([]);
  const [isTemplateDataLoading, setIsTemplateDataLoading] =
    React.useState(true);
  const [selectedRows, setSelectedRows] = React.useState([]);
  const [currentSelectedRow, setCurrentSelectedRow] = useState();
  const [currenActiveScreen, setCurrentActiveScreen] = useState({
    isDelete: false,
    isEdit: false,
    isDownload: false,
  });
  const [overlayContent, setOverlayContent] = React.useState("");
  const statusOverlayRef = React.useRef(null);
  const [isAPiCalled, setIsApiCalled] = React.useState(false);
  useEffect(() => {
    setIsTemplateDataLoading(true);
    api
      .get(`/api/web/reportDownload/getAll`)
      .then((res) => {
        setIsTemplateDataLoading(false);
        setIsApiCalled(true);
        setAllTemplateData(res?.data?.data);
      })
      .catch((err) => {});
  }, [refreshTemplateData]);
  return (
    <>
      <div className="report-template-data-table">
        {!isTemplateDataLoading &&
        isAPiCalled &&
        allTemplateData?.length === 0 ? (
          <NotFoundData currentNoFoundData={"files"} />
        ) : (
          <DataTable value={allTemplateData}>
            <Column
              header={() => {
                return (
                  <div
                    tooltip="hello"
                    className="main-header-template_name flex flex-wrap flex-row  align-items-center"
                  >
                    <div>
                      {" "}
                      <div
                        onClick={() => {
                          if (selectedRows.length < allTemplateData.length) {
                            setSelectedRows(allTemplateData);
                          } else {
                            setSelectedRows([]);
                          }
                        }}
                        className={`${allTemplateData.length > 0 && selectedRows.length === allTemplateData.length ? "checked" : ""}`}
                      >
                        {allTemplateData.length > 0 &&
                          selectedRows.length === allTemplateData.length && (
                            <CheckMark />
                          )}
                      </div>
                    </div>
                    <p>Template Name</p>
                  </div>
                );
              }}
              body={(rowData, { rowIndex }) => {
                const ischecked = selectedRows.some(
                  (item) => rowData.reportName === item.reportName
                );
                let template_namevalue = rowData?.reportName;
                let template_name = rowData?.reportName;
                if (template_name.length > 25) {
                  template_namevalue = template_name.substring(0, 25) + "...";
                } else {
                  template_namevalue = template_name;
                }

                return (
                  <div className="main-row-template_name flex flex-wrap flex-row  align-items-center">
                    <div>
                      <div
                        className={`${ischecked ? "checked" : ""}`}
                        onClick={() => {
                          if (
                            selectedRows.some(
                              (item) =>
                                rowData.template_name === item.template_name
                            )
                          ) {
                            setSelectedRows(
                              selectedRows.filter(
                                (item) =>
                                  item.template_name !== rowData.template_name
                              )
                            );
                          } else {
                            setSelectedRows([...selectedRows, rowData]);
                          }
                        }}
                      >
                        {ischecked && <CheckMark />}
                      </div>
                    </div>
                    <p
                      className="cursor-pointer"
                      onMouseEnter={(e) => {
                        if (template_name.length > 25) {
                          setOverlayContent(rowData?.reportName);
                          statusOverlayRef.current.show(e);
                        }
                      }}
                      onMouseLeave={() => statusOverlayRef.current.hide()}
                    >
                      {template_namevalue || "NIL"}
                    </p>
                    <OverlayPanel ref={statusOverlayRef}>
                      <div
                        style={{ maxWidth: "20rem", padding: "0.5rem 1rem" }}
                      >
                        <p
                          style={{
                            fontWeight: 400,
                            fontSize: "1.4rem",
                            overflow: "hidden",
                            border: "none",
                            margin: "0rem",
                            lineHeight: "1.8rem",
                            color: "#72728f",
                          }}
                        >
                          {" "}
                          {overlayContent}
                        </p>
                      </div>
                    </OverlayPanel>
                  </div>
                );
              }}
            />
            <Column
              header="Date"
              body={(rowData) => {
                return (
                  <span>
                    {rowData?.createdAt
                      ? moment(rowData?.createdAt) // Assuming rowData.date is a valid date string
                          .tz("America/New_York") // Convert to New York time (Eastern Time Zone)
                          .format("MM-DD-YYYY")
                      : "NIL"}
                  </span>
                );
              }}
            />

            <Column
              body={(rowData) => {
                return (
                  <TemplateAction
                    setCurrentSelectedRow={setCurrentSelectedRow}
                    currentSelectedRow={currentSelectedRow}
                    rowData={rowData}
                    setCurrentActiveScreen={setCurrentActiveScreen}
                  />
                );
              }}
              header="Actions"
            ></Column>
          </DataTable>
        )}
        {currenActiveScreen.isDelete ? (
          <DeleteTemplate
            setRefreshTemplateData={setRefreshTemplateData}
            currentSelectedRow={currentSelectedRow}
            setCurrentActiveScreen={setCurrentActiveScreen}
          />
        ) : currenActiveScreen.isEdit ? (
          <CreateTemplate
            setRefreshTemplateData={setRefreshTemplateData}
            handleCreateTemplate={handleCreateTemplate}
            isEdit={true}
            currentSelectedRow={currentSelectedRow}
            setCurrentActiveScreen={setCurrentActiveScreen}
          />
        ) : undefined}
        {isTemplateDataLoading && !isAPiCalled ? (
          <div className="loader-wrapper">
            <CommonLoaderBlue color="royalblue" sizehere={16} />
          </div>
        ) : (
          ""
        )}{" "}
      </div>
      {(currenActiveScreen.isDownload || currenActiveScreen.isView) && (
        <DownloadTemplate
          isView={currenActiveScreen.isView}
          currentSelectedRow={currentSelectedRow}
          setCurrentActiveScreen={setCurrentActiveScreen}
        />
      )}
    </>
  );
};

export default TemplateData;
